// src/pages/Folder/components/KPIViewer.tsx

import { InputAdornment, SxProps, TextField, Theme } from '@mui/material'

import { sensorUnit, userLocales } from '../../../api'
import { HStack } from '../../../components'

type KPIViewerProps = {
  exportModal?: boolean
  kpiData: {
    average: number | string
    max: number
    min: number
    total: number
    type: string
  }
  medium: string
  precision?: number
  consumptionType?: boolean
  sx?: SxProps<Theme>
}

export const KPIViewer = ({
  exportModal,
  kpiData,
  medium,
  precision = 2,
  consumptionType = false,
  sx,
  ...rest
}: KPIViewerProps) => {
  const { average, max, min, total, type } = kpiData

  let metrics

  switch (type) {
    case 'consumption':
      metrics = {
        label: consumptionType ? 'TB Gesamt' : 'Verbrauch',
        unit: sensorUnit(medium),
      }
      break

    case 'price':
      metrics = { label: 'Kosten', unit: '€' }
      break

    case 'co2':
      metrics = { label: 'CO₂ Ausstoß', unit: 'kg' }
      break

    default:
      console.error('unhandled KPIViewer type', type)
  }

  const format = value =>
    isNaN(value)
      ? '-'
      : Number(value).toLocaleString(userLocales, {
          minimumFractionDigits: precision,
          maximumFractionDigits: precision,
        })

  const data = [
    { label: metrics.label, value: format(total) },
    { label: 'Minimum', value: format(min) },
    { label: 'Maximum', value: format(max) },
    { label: 'Durchschnitt', value: format(average) },
  ]

  return (
    <HStack sx={sx} {...rest}>
      {data.map(item => {
        const { label, value } = item

        return (
          <TextField
            InputProps={{
              endAdornment: (
                <InputAdornment position={'end'}>{metrics.unit}</InputAdornment>
              ),
              readOnly: true,
            }}
            key={label}
            label={label}
            sx={{ width: 180 }}
            value={value}
            variant={exportModal ? 'filled' : 'outlined'}
          />
        )
      })}
    </HStack>
  )
}
